
















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import PicUpload from "@/components/picUpload/index.vue";

@Component({
  name: "onlineBooking",
  components: {
    questionSettingTemplate,
    PicUpload,
  },
})
export default class onlineBooking extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  private postForm = {
    title: "", // 标题
    required: "1", // 是否必填
    jsonConfig: {
      showIndex: true,
    },
  };

  private rules = {
    title: [{ required: true, message: "请输入标题", trigger: "blur" }],
    required: [{ required: true, message: "请选择是否必填", trigger: "blur" }],
    "jsonConfig.appointmentName": [{ required: true, message: "请输入预约事项名称", trigger: "blur" }],
    "jsonConfig.imgUrl": [{ required: true, message: "请上传图片", trigger: "change" }],
    "jsonConfig.weeklyAppointmentDate": [{ required: true, message: "请选择每周可约日期", trigger: "change" }],
    "jsonConfig.dailyStartAndEndTime": [{ required: true, message: "请选择每日起止时间", trigger: "change" }],
    "jsonConfig.hourlyDuration": [
      { required: true, message: "请输入每时段持续时间", trigger: "blur" },
      { validator: this.validateHourlyDuration, trigger: "blur" },
    ],
    "jsonConfig.intervalTime": [
      { required: true, message: "请输入间隔时间", trigger: "blur" },
      { validator: this.validateHourlyDuration, trigger: "blur" },
    ],
    "jsonConfig.appointmentDateRange": [{ required: true, message: "请选择限制截止日期", trigger: "change" }],
  };
  private validateHourlyDuration(rule: any, value: any, callback: any) {
    if (value % 5 > 0) {
      callback(new Error("请设置为5的倍数！"));
    } else {
      callback();
    }
  }

  private weeklyOptions = [
    { label: "周一", value: "MONDAY" },
    { label: "周二", value: "TUESDAY" },
    { label: "周三", value: "WEDNESDAY" },
    { label: "周四", value: "THURSDAY" },
    { label: "周五", value: "FRIDAY" },
    { label: "周六", value: "SATURDAY" },
    { label: "周日", value: "SUNDAY" },
  ];

  get dateRangePickerOptions() {
    const _than = this;
    const dateRangePickerOptions = {
      disabledDate(time: any) {
        if ((_than.postForm.jsonConfig as any).appointmentDateRange.length > 0) return new Date((_than.postForm.jsonConfig as any).appointmentDateRange[0]).getTime() - 24 * 60 * 60 * 1000 > time.getTime() || new Date((_than.postForm.jsonConfig as any).appointmentDateRange[1]).getTime() < time.getTime();
        return false;
      },
    };
    return dateRangePickerOptions;
  }

  get quotaLabel() {
    return (this.postForm.jsonConfig as any).appointmentMethod === "APPOINTMENT_METHOD_PERIOD" ? "每时段名额" : "每日名额";
  }

  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }

  addDateRange() {
    (this.postForm.jsonConfig as any).notAppointmentDateRange.push([]);
  }
  deleteDateRange(index: number) {
    (this.postForm.jsonConfig as any).notAppointmentDateRange.splice(index, 1);
  }

  getFormInstance() {
    return this.$refs.postForm as any;
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  async validate() {
    return await this.getFormInstance()
      .validate()
      .catch((err: any) => {
        return err;
      });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
}
